import { useIntl } from 'react-intl';

import { T } from 'types';

export const useI18n = (): T => {
  const intl = useIntl();

  return (id, options) => {
    const { defaultMessage = '', ...ommitedOptions } = options || {};

    return intl.formatMessage({ id, defaultMessage }, ommitedOptions);
  };
};
